<template>
  <LayoutContainer
    :id="data.cssId"
    class="flex flex-col"
    :aos="{ fadeDirection: 'fade-right', delay: 300 }"
  >
    <LayoutBlock
      v-if="data.categoryH2 || data.headlineH2 || data.text || data.button"
    >
      <UtilityHeadline
        v-if="data.headlineH2"
        :class="`dbc-text-color-${data.headlineH2Color}`"
        :text="data.headlineH2"
        :level="2"
        :category="{ text: data.categoryH2, color: data.categoryH2Color }"
      />
      <div v-if="data.text" class="max-w-[82ch]">
        <UtilityText :text="data.text" />
      </div>
    </LayoutBlock>
    <LayoutBlock
      class="flex gap-x-[4rem] gap-y-[2rem] justify-between max-tablet:flex-wrap"
    >
      <LayoutBlock class="basis-[120ch] self-center">
        <component
          :is="data.listStyle === 'number' ? 'ol' : 'ul'"
          class="list-none p-0 m-0 flex flex-col gap-y-[32px] [counter-reset:list-counter]"
        >
          <li
            v-for="benefit in data.benefits"
            class="flex gap-x-[16px] [counter-increment:list-counter] before:w-[32px] before:h-[32px] before:shrink-0"
            :class="[
              {
                'before:content-(--content-checkmark)':
                  data.listStyle === 'checkmark',
              },
              {
                'before:content-[counter(list-counter)] before:rounded-full before:bg-primary before:flex before:justify-center before:items-center before:text-white before:text-base':
                  data.listStyle === 'number',
              },
              { 'before:content-none': data.listStyle === 'custom' },
            ]"
          >
            <div
              v-if="data.listStyle === 'custom' && benefit.icon"
              class="w-[80px] h-[80px] shrink-0"
              aria-hidden="true"
            >
              <UtilityImage
                format="f1-1"
                :src="benefit.icon.url"
                :width="80"
                :height="80"
              />
            </div>
            <div class="flex flex-col gap-y-[8px] justify-center">
              <UtilityHeadline class="m-0" :level="3" :text="benefit.heading" />
              <UtilityText
                class="m-0"
                v-if="benefit.text"
                :text="benefit.text"
              />
            </div>
          </li>
        </component>
        <UtilityButton
          v-if="data.button"
          class="mt-[3rem]"
          :button="data.button"
        />
      </LayoutBlock>
      <LayoutBlock
        class="self-center relative grow basis-full"
        :class="`${imagePositionDesktop} ${imagePositionMobile}`"
      >
        <UtilityImage
          v-if="data.image && data.image.image && data.image.image[0]"
          :format="data?.image?.format ? data?.image?.format : undefined"
          :src="data.image.image[0].url"
          :alt="data.image.alt"
          loading="lazy"
          :copyright="data.image.copyright"
        />
      </LayoutBlock>
    </LayoutBlock>
  </LayoutContainer>
</template>

<script setup lang="ts">
const props = defineProps<{
  content: ContentBenefitsMedia
}>()

const data = normalizeBenefitsMedia(props.content)
const imagePositionDesktop = ref(
  data.imagePositionDesktop === 'left' ? '-order-1' : 'order-100'
)
const imagePositionMobile = ref(
  data.imagePositionMobile === 'top'
    ? 'max-tablet:-order-1'
    : 'max-tablet:order-100'
)
</script>
